import type { PixelRuntimeContext } from '@/runtime/PixelRuntimeContext';

import { BaseAutoTracker } from '../../auto/BaseAutoTracker';
import type { TrackerFactory } from '../../tracks/TrackerFactory';

const DEFAULT_KEYWORD_EVENTS: Array<{
  keyword: string;
  type: 'INITIATE_CHECKOUT' | 'ADD_TO_CART';
}> = [
  { keyword: 'comprar agora', type: 'INITIATE_CHECKOUT' },
  { keyword: 'finalizar compra', type: 'INITIATE_CHECKOUT' },
  { keyword: 'checkout', type: 'INITIATE_CHECKOUT' },
  { keyword: 'comprar', type: 'ADD_TO_CART' },
];

export class TextDetector extends BaseAutoTracker {
  readonly name = 'TextDetector';
  private readonly factory: TrackerFactory;

  private readonly keywords: string[];

  constructor(
    context: PixelRuntimeContext,
    factory: TrackerFactory,
    keywords: string[] = []
  ) {
    super(context);
    this.factory = factory;
    this.keywords = keywords;
  }

  protected onInit(): void {
    if (!this.isDocumentAvailable()) return;
    this.addDocumentListener('click', event => this.handleClick(event), true);
  }

  protected onDestroy(): void {}

  private handleClick(event: Event): void {
    const element =
      event.target instanceof Element
        ? event.target.closest('a,button,[role="button"],input[type="submit"]')
        : null;

    if (!element?.textContent) return;

    const text = element.textContent.trim().toLowerCase();
    if (!text) return;

    for (const rule of DEFAULT_KEYWORD_EVENTS) {
      if (
        this.keywords.some(k => k.toLowerCase() === rule.keyword) &&
        text.includes(rule.keyword)
      ) {
        this.factory.trackAuto(
          rule.type,
          {},
          {
            origin: 'auto:text',
          }
        );
        return;
      }
    }

    for (const keyword of this.keywords) {
      const normalized = keyword.toLowerCase();
      if (text.includes(normalized)) {
        this.factory.trackAuto(
          'INITIATE_CHECKOUT',
          {},
          {
            origin: 'auto:text',
          }
        );
        return;
      }
    }
  }
}
